import { render, staticRenderFns } from "./RoomTypes.vue?vue&type=template&id=4b91d237&"
import script from "./RoomTypes.vue?vue&type=script&lang=js&"
export * from "./RoomTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomTypes.vue"
export default component.exports